import { pruefpunkt, type PruefpunktKey } from '../../shared/pruefpunkte.js';
import { ersetze, h, statusMarke } from '../dom.js';
import { ereignisse, ergebnisVon } from '../ergebnisse.js';
import { formatiereZeitpunkt } from '../zeit.js';

/** Sammelt Aufräumarbeiten einer Ansicht (Ereignisse, Timer, Kamera). */
export class Aufraeumer {
  private readonly arbeiten: (() => void)[] = [];

  dazu(arbeit: () => void): void {
    this.arbeiten.push(arbeit);
  }

  hoere(ziel: EventTarget, art: string, behandlung: EventListener): void {
    ziel.addEventListener(art, behandlung);
    this.dazu(() => ziel.removeEventListener(art, behandlung));
  }

  intervall(arbeit: () => void, ms: number): void {
    const id = window.setInterval(arbeit, ms);
    this.dazu(() => window.clearInterval(id));
  }

  alles = (): void => {
    for (const arbeit of this.arbeiten.splice(0).reverse()) {
      try {
        arbeit();
      } catch {
        // Aufräumen darf nie den Seitenwechsel verhindern.
      }
    }
  };
}

export function kopf(titel: string, einleitung?: string): HTMLElement[] {
  return [h('a', { href: '/', class: 'zurueck' }, h('span', { 'aria-hidden': 'true' }, '← '), 'Übersicht'), h('h1', {}, titel), ...(einleitung ? [h('p', { class: 'einleitung' }, einleitung)] : [])];
}

/** Zeigt den aktuellen Stand eines Prüfpunkts und aktualisiert sich bei neuen Ergebnissen. */
export function pruefpunktStand(key: PruefpunktKey, aufraeumer: Aufraeumer): HTMLElement {
  const element = h('div', { class: 'stand', id: key, 'aria-live': 'polite' });
  const zeichne = () => {
    const e = ergebnisVon(key);
    ersetze(
      element,
      h('div', { class: 'stand-kopf' }, h('span', { class: 'stand-titel' }, pruefpunkt(key).titel), statusMarke(e?.status ?? 'offen')),
      e
        ? h(
            'p',
            { class: 'stand-text' },
            e.text,
            h('span', { class: 'stand-zeit' }, ` · ${formatiereZeitpunkt(e.erfasstAm)}${e.modus === 'browser' ? ' · im Browser' : ''}${e.gesendet ? '' : ' · noch nicht gesendet'}`),
          )
        : h('p', { class: 'stand-text leise' }, 'Noch nicht geprüft.'),
    );
  };
  zeichne();
  aufraeumer.hoere(ereignisse, 'geaendert', zeichne);
  return element;
}
